import { Component, OnInit, Input } from '@angular/core';
import {
  NotificationItem,
  NotificationsService,
} from '@services/notifications.service';

@Component({
    selector: 'scaffold-notification-bar',
    templateUrl: './notification-bar.component.html',
    styleUrls: ['./notification-bar.component.scss'],
    standalone: false
})
export class NotificationBarComponent implements OnInit {
  @Input() notification: NotificationItem;
  constructor(private notificationService: NotificationsService) {}

  ngOnInit(): void {}
  /**Dismiss the notification */
  dismiss() {
    this.notificationService.dismissBar(this.notification);
  }
}
